import Vue from 'vue'
import {
  toFixedDecimal,
  numberWithComma,
  formatDate,
  displayKYCStatus,
  displayFromKeyToText,
  padNumber,
  shortenHex
} from './helper'

Vue.filter('toFixedDecimal', toFixedDecimal)
Vue.filter('numberWithComma', numberWithComma)
Vue.filter('formatDate', formatDate)
Vue.filter('displayKYCStatus', displayKYCStatus)
Vue.filter('displayFromKeyToText', displayFromKeyToText)
Vue.filter('padNumber', padNumber)
Vue.filter('shortenHex', shortenHex)



// WEBPACK FOOTER //
// ./src/utils/viewFilter.js